module.exports = __webpack_public_path__ + "static/media/p-Prism.70fcfe11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-Prism.png
// module id = 179
// module chunks = 0